import type { BadgeColor } from '@/components/Badge';

/**
 * Rodzaj kartoteki — jedno źródło prawdy koloru badge w CAŁEJ aplikacji.
 *
 *  - `system` (kartoteka systemowa: wbudowana — Pracownicy, Kontrahenci… — lub oparta
 *    o klasę dokumentu — Delegacja, teczka, Wnioski urlopowe…) → **zielony**.
 *  - `custom` (kartoteka utworzona w Kreatorze jako nowa własna tabela — Badania lekarskie,
 *    Szkolenia BHP…) → **pomarańczowy** (paleta `amber`).
 *
 * Rozpoznanie po stronie serwera (`lib/module-builder/kartoteka-kind.ts`); tu tylko
 * mapowanie rodzaju na kolor + klucz etykiety. Nowe miejsca pokazujące pochodzenie
 * kartoteki reużywają ten sam moduł (i komponent `KartotekaBadge`), zamiast wpisywać
 * kolory na własną rękę.
 */
export type KartotekaKind = 'system' | 'custom';

export const KARTOTEKA_KIND_BADGE_COLOR: Record<KartotekaKind, BadgeColor> = {
  system: 'green',
  custom: 'amber',
};

export const KARTOTEKA_KIND_LABEL_KEY: Record<KartotekaKind, string> = {
  system: 'kartoteka.kind.system',
  custom: 'kartoteka.kind.custom',
};

/**
 * Rozpoznanie rodzaju kartoteki ze strategii DDL encji — mirror serwerowego
 * `lib/module-builder/kartoteka-kind.ts`. Do użytku tam, gdzie front ma `ddlStrategy`
 * pod ręką (np. edytor szablonu) i nie dostaje gotowego `kind` z API.
 *
 * UWAGA — kontekst decyduje. Ta reguła obowiązuje w panelu ITE (admin), gdzie odróżniamy
 * kartotekę systemową od tej zbudowanej w Kreatorze. U TENANTA jest inaczej: wszystko, co
 * przyszło od nas / od admina (zainstalowane moduły i szablony), jest dla tenanta
 * SYSTEMOWE — „z kreatora" byłaby tylko kartoteka utworzona przez samego tenanta. Nie
 * przenoś tej funkcji do widoków tenanta bez zmiany źródła `kind`.
 */
export function kartotekaKindFromDdlStrategy(ddlStrategy: string): KartotekaKind {
  return ddlStrategy === 'reference_to_system_entity' || ddlStrategy === 'document_class'
    ? 'system'
    : 'custom';
}
